import React, { useState, useRef, useEffect } from "react";
import { useStore } from "stores/store";
import gsap from "gsap";

export default function YearBox({ setSelectedYear }) {
  const lenis = useStore(({ lenis }) => lenis);
  const [activeYear, setActiveYear] = useState(2025);
  const [isDragging, setIsDragging] = useState(false);
  const scrollerRef = useRef(null);
  const containerRef = useRef(null);
  const scrollTrackRef = useRef(null);

  const startYear = 1999;
  const endYear = 2025;
  const years = Array.from(
    { length: endYear - startYear + 1 },
    (_, index) => startYear + index
  );

  useEffect(() => {
    setSelectedYear(activeYear);
  }, [activeYear, setSelectedYear]);

  const handleMouseEnter = () => {
    if (lenis) {
      lenis.stop();
    }
  };

  const handleMouseLeave = () => {
    if (lenis) {
      lenis.start();
    }
  };

  const handleMouseDown = (e) => {
    setIsDragging(true);
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;

    const scrollTrack = scrollTrackRef.current;
    const scroller = scrollerRef.current;

    const trackRect = scrollTrack.getBoundingClientRect();
    const scrollerHeight = scroller.offsetHeight;

    let newY = e.clientY - trackRect.top - scrollerHeight / 2;

    // 스크롤 영역 내로 제한
    newY = Math.max(0, Math.min(newY, trackRect.height - scrollerHeight));

    // GSAP을 사용하여 부드러운 스크롤러 이동
    gsap.to(scroller, {
      top: newY,
      duration: 0.3,
      ease: "power2.out",
    });

    // 연도 업데이트
    const scrollPercent = newY / (trackRect.height - scrollerHeight);
    const yearIndex = Math.round(scrollPercent * (years.length - 1));
    const newYear = years[years.length - 1 - yearIndex];

    if (newYear !== activeYear) {
      setActiveYear(newYear);
    }
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  const getStyle = (year) => {
    const index = years.indexOf(year);
    const selectedIndex = years.indexOf(activeYear);
    const offset = selectedIndex - index;
    const opacity = Math.max(0, 1 - 0.2 * Math.abs(offset));
    const topPosition = 20 + offset * 16;

    return {
      opacity,
      position: "absolute",
      top: `${topPosition}%`,
      left: "50%",
      fontSize: offset === 0 ? "48px" : "36px",
      transform: "translateX(-50%)",
      transition: "opacity 0.3s, font-size 0.3s, top 0.3s",
      userSelect: "none",
    };
  };

  return (
    <>
      <div
        ref={containerRef}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        style={{
          position: "relative",
          width: "100%",
          height: "400px",
          marginRight: "2rem",
          overflow: "hidden",
        }}
      >
        {years.map((year) => (
          <div key={year} style={getStyle(year)}>
            {year}
          </div>
        ))}
      </div>
      <div ref={scrollTrackRef} className="year-box-scroll">
        <span
          ref={scrollerRef}
          className="year-box-scroler"
          onMouseDown={handleMouseDown}
          onMouseMove={handleMouseMove}
          onMouseUp={handleMouseUp}
          onMouseLeave={handleMouseUp}
          style={{ cursor: isDragging ? "grabbing" : "grab" }}
        ></span>
      </div>
    </>
  );
}
